import { render, staticRenderFns } from "./WidthSelector.vue?vue&type=template&id=48d9ca9c&"
import script from "./WidthSelector.vue?vue&type=script&lang=js&"
export * from "./WidthSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports